import { render, staticRenderFns } from "./AcertoDespesa.vue?vue&type=template&id=21e49614"
import script from "./AcertoDespesa.vue?vue&type=script&lang=js"
export * from "./AcertoDespesa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports